import React, { useEffect } from "react";
import { JhPopupDrawer } from "designPackages/popupPackage";
import { JhText } from "designPackages/textPackage";
import { JhButton } from "designPackages/buttonPackage";
import { AlertCircle } from "lucide-react";
import dynamic from "next/dynamic";
const NewShareLink = dynamic(() => import("../ShareLink/NewShareLink"), {
  ssr: false
});
import useModalStore from "../../zustandStores/useModalStore";

const ShareJobModal = () => {
  const { modalData, setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));

  // Clean up the modal state when unmounting
  useEffect(() => {
    return () => {
      if (modalData?.type === "shareJobModal") {
        setModalData({
          state: "close",
          type: ""
        });
      }
    };
  }, []);

  const handleModalClose = () => {
    // Completely reset the modal state, not just closing it
    setModalData({
      state: "close",
      type: "",
      data: null
    });
  };

  const isOpen = 
    modalData?.state === "open" && 
    modalData?.type === "shareJobModal";

  const isLoading = modalData?.data?.loading;
  const hasError = modalData?.data?.error;
  const shareInfo = modalData?.data?.shareInfo;
  const jobTitle = modalData?.data?.jobTitle;

  // Return null if not open to ensure complete cleanup
  if (!isOpen) return null;

  return (
    <JhPopupDrawer
      className="tw-root"
      open={isOpen}
      onClose={handleModalClose}
      position="center"
    >
      <div>
        {isLoading ? (
          <div className="p-4 flex justify-center items-center min-h-[200px]">
            <JhText variant="body1" color="muted-foreground">Loading share options...</JhText>
          </div>
        ) : hasError ? (
          <div className="p-4 flex flex-col items-center gap-4 min-h-[200px]">
            <AlertCircle size={32} className="text-destructive" />
            <JhText variant="body1" color="destructive">Failed to load sharing options</JhText>
            <JhButton variant="outline" onClick={handleModalClose}>
              Close
            </JhButton>
          </div>
        ) : shareInfo ? (
          <NewShareLink 
            shareInfo={shareInfo} 
            onClose={handleModalClose}
            title={jobTitle ? `Share ${jobTitle}` : "Share Job"}
          />
        ) : null}
      </div>
    </JhPopupDrawer>
  );
};

export default ShareJobModal; 